"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIBreadcrumbs;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var renderBreadcrumb = function renderBreadcrumb(children, hasArrow, isBackLink) {
  return _react.default.createElement("span", null, hasArrow && _react.default.createElement(_UIIcon.default, {
    className: (0, _classnames.default)('private-breadcrumbs__arrow', {
      'private-breadcrumbs__arrow--back': isBackLink
    }),
    name: isBackLink ? 'left' : 'right'
  }), children);
};

var renderChildren = function renderChildren(children, singleBreadcrumbIsBackLink) {
  var isValidChild = function isValidChild(child) {
    if (typeof child === 'string') {
      return child.trim().length > 0;
    }

    return child;
  };

  var childrenArray = _react.default.Children.toArray(children);

  var validChildren = childrenArray.filter(isValidChild);
  var isOnlyChild = validChildren.length === 1;

  var breadcrumbs = _react.Children.map(validChildren, function (child, index) {
    var ariaCurrent = !isOnlyChild && index === validChildren.length - 1 ? 'location' : null;
    var isBackLink = isOnlyChild && singleBreadcrumbIsBackLink;
    var hasArrow = isBackLink || index !== 0;

    if ((0, _react.isValidElement)(child)) {
      return (0, _react.cloneElement)(child, {
        'aria-current': ariaCurrent,
        children: renderBreadcrumb(child.props.children, hasArrow, isBackLink),
        className: 'private-breadcrumbs__item',
        key: index
      });
    }

    return _react.default.createElement("span", {
      "aria-current": ariaCurrent,
      className: "private-breadcrumbs__item"
    }, renderBreadcrumb(child, hasArrow, isBackLink));
  });

  if (isOnlyChild && !singleBreadcrumbIsBackLink) {
    breadcrumbs.push(_react.default.createElement("span", {
      className: "private-breadcrumbs__item",
      key: "x"
    }, renderBreadcrumb(null, true, false)));
  }

  return breadcrumbs;
};

function UIBreadcrumbs(props) {
  var className = props.className,
      children = props.children,
      flush = props.flush,
      singleBreadcrumbIsBackLink = props.singleBreadcrumbIsBackLink,
      wrap = props.wrap,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "children", "flush", "singleBreadcrumbIsBackLink", "wrap"]);
  return _react.default.createElement("nav", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-breadcrumbs', className, {
      'private-breadcrumbs--flush': flush,
      'private-breadcrumbs--no-wrap': !wrap
    })
  }), renderChildren(children, singleBreadcrumbIsBackLink));
}

UIBreadcrumbs.propTypes = {
  children: _propTypes.default.node,
  flush: _propTypes.default.bool.isRequired,
  singleBreadcrumbIsBackLink: _propTypes.default.bool.isRequired,
  wrap: _propTypes.default.bool.isRequired
};
UIBreadcrumbs.defaultProps = {
  flush: false,
  role: 'navigation',
  singleBreadcrumbIsBackLink: true,
  wrap: false
};
UIBreadcrumbs.displayName = 'UIBreadcrumbs';
module.exports = exports.default;